import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5728a1cc")

_pushScopeId("data-v-5728a1cc")
const _hoisted_1 = { class: "w-full flex py-3 flex-col gap-y-4 shipment-id-radio" }
const _hoisted_2 = /*#__PURE__*/_createVNode("label", {
  for: "shipmentId1",
  class: "cursor-pointer"
}, "All", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("label", {
  for: "shipmentId2",
  class: "cursor-pointer"
}, "Custom", -1)
const _hoisted_4 = {
  key: 0,
  class: "w-full flex flex-col gap-y-4 pl-8"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_custom_dropdown = _resolveComponent("custom-dropdown")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_custom_dropdown, {
      placeholder: _ctx.placeholder,
      value: _ctx.selectedValueName,
      isDisabled: false,
      isExpand: _ctx.selectShipmentIdOpen,
      "onUpdate:isExpand": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectShipmentIdOpen = $event))
    }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.watchRadioValueChanges) + " ", 1),
        _createVNode("div", _hoisted_1, [
          _createVNode("div", {
            class: "p-field-radiobutton gap-x-3 flex flex-row",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
          }, [
            _createVNode(_component_RadioButton, {
              id: "shipmentId1",
              name: "shipment-id",
              value: "All",
              modelValue: _ctx.radioValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.radioValue = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_2
          ]),
          _createVNode("div", {
            class: "p-field-radiobutton gap-x-3 flex flex-row",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
          }, [
            _createVNode(_component_RadioButton, {
              id: "shipmentId2",
              name: "shipment-id",
              value: "Custom",
              modelValue: _ctx.radioValue,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.radioValue = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_3
          ]),
          (_ctx.radioValue === 'Custom')
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode(_component_MultipleSelectSearch, {
                  "server-side": false,
                  options: _ctx.optionShipmentId,
                  modelValue: _ctx.selectedShipmentId,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedShipmentId = $event)),
                  isLoading: _ctx.shipmentIdLoading,
                  showSelected: false,
                  placeholder: "Pilih",
                  onFocus: _ctx.fetchShipmentId,
                  onChange: _ctx.onSelectCustom
                }, null, 8, ["options", "modelValue", "isLoading", "onFocus", "onChange"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["placeholder", "value", "isExpand"]),
    _createVNode(_component_MultipleSelectSearch, {
      options: _ctx.optionShipmentId,
      modelValue: _ctx.selectedShipmentId,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedShipmentId = $event)),
      placeholder: "Pilih shipment ID",
      isLoading: false,
      hideInput: true,
      allEnabled: "",
      onChange: _ctx.removeChoice
    }, null, 8, ["options", "modelValue", "onChange"])
  ], 64))
})